<template>
  <button
    class="klickbox-step-button"
    v-if="step.kind === 'multiple-choice' || step.kind === 'yes-no' || step.kind === 'welcome'"
    @click="stepSetActive(step);sidebarChangePanel('jump')">
    <i class="kp-panel-jump-o"></i>
    <span class="badge" v-show="jumpCount(step.jumps)">{{ jumpCount(step.jumps) }}</span>
    <span class="step-subtitle">{{ $t('general.labels.destinations') }}</span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'stepSetActive',
    'sidebarChangePanel',
  ]),
  computed: mapGetters({
    jumpCount: 'jumpCount',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** ButtonJump.vue?668f317e
 **/